export default __webpack_public_path__ + "static/media/Dumpbell.d64ea81a.svg";